export default "__VITE_ASSET__Btoe3sll__"